<!-- <ng-container *ngIf="isLoading">
    <div class="progress progress-modal">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
             style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</ng-container> -->

<div class="modal-header">
    <div class="modal-title h4">Vaciar carrito</div>
</div>
<div class="modal-body">

    <ng-container>
        <span>¿Seguro que deseas vaciar el carrito?</span>
    </ng-container>
</div>

<div class="modal-footer">
    <div>

        <!--   <span
            style="margin-right: 3rem !important;" class="spinner spinner-primary mr-5">
          </span> -->

        <button type="button" class="btn btn-light btn-elevate mr-1" (click)="modal.dismiss()">
           Cancelar
        </button>&nbsp;
        <button type="button" class="btn btn-primary btn-elevate" (click)="clear()">
            Aceptar
        </button>
    </div>
</div>
